export const golfMonthlyTheme = `
  --body-bg-color: #f4f4f4;
  --header-bg-golor: #052643;
  --odd-cell-bg-color-highlighted: #1ed560;
  --odd-cell-color-highlighted: #20242e;
`;
